// extracted by mini-css-extract-plugin
export default {"MyNoteMainText":"AutoExpandingTextarea_MyNoteMainText__QQ5WC"};